var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SaiDropDown',{attrs:{"value":_vm.value,"name":_vm.name,"labelBy":_vm.labelBy,"trackBy":_vm.trackBy,"options":_vm.options,"placeholder":_vm.placeholder,"isLoading":_vm.isOptionsLoading},on:{"change":function($event){return _vm.$emit('change', $event)},"open":_vm.loadOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }